import VueLib from 'vue'
import merge from 'lodash.merge'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002Fbdf883b1bf6f4919a6fec2023c30a081@sentry.io\u002F1437497",
    environment:"production",
    beforeSend:function(event) {
        try {
          // throw new Error("config error")
          const key = 'User-Agent'
          if (event.request && event.request.headers && event.request.headers[key]) {
            const userAgent = event.request.headers[key].toLowerCase()
            // Firefox,Opera,SamsungBrowserの場合は推奨環境ではないためfalseを返す
            if (userAgent.indexOf('firefox') != -1 || userAgent.indexOf('opera') != -1 || userAgent.indexOf('SamsungBrowser') != -1) return null

            // iPhone場合 バージョンが9より低い場合はfalseを返す
            if (userAgent.match(/iphone.+mobile/)) {
              const target = userAgent.match(/iphone os (.+?) like/)
              if (target && target.length) {
                const iOSVersion = parseFloat(target[1].replace('_', '.'))
                if (iOSVersion < 9) return null
              }
            } else if (userAgent.match(/android.+mobile/)) {
              // Androidのバージョンが4.4より低い場合はfalseを返す
              const androidOSVersion = parseFloat(userAgent.slice(userAgent.indexOf('android') + 8))
              if (androidOSVersion < 4.4) return null
            }
          }
          return event
        } catch (error) {
          return event
        }
      },
    allowUrls:[],
    denyUrls:[/ampproject|amphtml|gpt|/i],
    ignoreErrors:[/setTimeout is not a function. \(In /i,/dictionary not an array/i,"window.googletag.destroySlots is not a function","link.__prefetch is not a function. (In 'link.__prefetch()', 'link.__prefetch' is undefined)","Resource blocked by content blocker","null is not an object (evaluating 'g.readyState')"],
    release:"6283ece3e039af0efe70838142748286db439661"
  }

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  config.integrations = [
    new Dedupe({}),
    new ExtraErrorData({}),
    new ReportingObserver({}),
    new RewriteFrames({}),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false}})
  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
